<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {
        OpenGraphMetaTag,
        TwitterMetaTags,
        use3rdParties,
        useAsyncData,
        useHead,
        useHostSettings,
        useHTMLAttrsLang,
        useOpenGraphMetaTags,
        useScripts,
        useSeoMeta,
        useTranslation,
        useTwitterMetaTags,
    } from '#imports';

    // Composables
    const {t} = useTranslation();

    const title = t('signup.client.meta.title');
    const description = t('seo.malt.meta.description');

    use3rdParties();
    useHTMLAttrsLang();
    useSeoMeta({
        title,
        description,
        robots: 'noindex',
    });
    useOpenGraphMetaTags(new OpenGraphMetaTag({title, t}));
    useTwitterMetaTags(new TwitterMetaTags({card: 'summary', title, t}));

    const {data: hostSettings, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(hostSettings.value);
        useHead({script: await loadScripts()});
    }
</script>
